/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferOrderAndOfferSearchFilterSortOrder = 'ByOfferOrderNumberASC' | 'ByCompanyNumberASC' | 'ByTopJobASC' | 'ByJobBlitzASC' | 'ByRefreshASC' | 'ByTableEntryASC' | 'ByOfferOrderStatusASC' | 'ByProductTypeASC' | 'ByPublishDateASC' | 'ByCreatedAtASC' | 'ByCompanyNameASC' | 'ByProductVariantASC' | 'ByKalaydoASC' | 'ByItJobsASC' | 'ByItJobsDESC' | 'ByKalaydoDESC' | 'ByProductVariantDESC' | 'ByCompanyNameDESC' | 'ByCreatedAtDESC' | 'ByPublishDateDESC' | 'ByProductTypeDESC' | 'ByOfferOrderStatusDESC' | 'ByTableEntryDESC' | 'ByRefreshDESC' | 'ByJobBlitzDESC' | 'ByTopJobDESC' | 'ByCompanyNumberDESC' | 'ByOfferOrderNumberDESC';

export const OfferOrderAndOfferSearchFilterSortOrder = {
    ByOfferOrderNumberASC: 'ByOfferOrderNumberASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByCompanyNumberASC: 'ByCompanyNumberASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByTopJobASC: 'ByTopJobASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByJobBlitzASC: 'ByJobBlitzASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByRefreshASC: 'ByRefreshASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByTableEntryASC: 'ByTableEntryASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByOfferOrderStatusASC: 'ByOfferOrderStatusASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByProductTypeASC: 'ByProductTypeASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByPublishDateASC: 'ByPublishDateASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByCreatedAtASC: 'ByCreatedAtASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByCompanyNameASC: 'ByCompanyNameASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByProductVariantASC: 'ByProductVariantASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByKalaydoASC: 'ByKalaydoASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByItJobsASC: 'ByItJobsASC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByItJobsDESC: 'ByItJobsDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByKalaydoDESC: 'ByKalaydoDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByProductVariantDESC: 'ByProductVariantDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByCompanyNameDESC: 'ByCompanyNameDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByCreatedAtDESC: 'ByCreatedAtDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByPublishDateDESC: 'ByPublishDateDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByProductTypeDESC: 'ByProductTypeDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByOfferOrderStatusDESC: 'ByOfferOrderStatusDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByTableEntryDESC: 'ByTableEntryDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByRefreshDESC: 'ByRefreshDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByJobBlitzDESC: 'ByJobBlitzDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByTopJobDESC: 'ByTopJobDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByCompanyNumberDESC: 'ByCompanyNumberDESC' as OfferOrderAndOfferSearchFilterSortOrder,
    ByOfferOrderNumberDESC: 'ByOfferOrderNumberDESC' as OfferOrderAndOfferSearchFilterSortOrder
};

